import { PageError } from '@/components/PageError'
import { useMe } from '@/hooks/queries/useMe'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: me, error } = useMe()
  const navigate = useNavigate()

  if (!me) return null
  if (me.permissions && me.permissions.length === 0) navigate({ to: '/unverified' })
  if (error) return <PageError message={error.message} global />

  return <Outlet />
}
